import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "src/_metronic/helpers";

export interface IValidationIconHandler {
    validation?: boolean;
    className?: string;
    validIconPath?: string;
    validIconFill?: string;
    invalidIconPath?: string;
    invalidIconFill?: string;
    width?: string;
}

const ValidationIconHandler = (props: IValidationIconHandler) => {
    const {
        validation = true,
        className,
        width = "16px",
        validIconPath = "/media/icons/duotune/general/tick.svg",
        invalidIconPath = "/media/icons/duotune/general/cross.svg",
        validIconFill = "var(--kt-text-success)",
        invalidIconFill = "var(--kt-text-danger)",
    } = props;
    return (
        <>
            {validation ? (
                <div className={className}>
                    <SVG width={width} fill={validIconFill} src={toAbsoluteUrl(validIconPath)} />
                </div>
            ) : (
                <div className={className}>
                    <SVG
                        fill={invalidIconFill}
                        width={width}
                        src={toAbsoluteUrl(invalidIconPath)}
                    />
                </div>
            )}
        </>
    );
};

export default ValidationIconHandler;
